enum ActionType {
    REQUEST_CALL_HOME_REQUESTS = '[CALL_HOME_REQUESTS] GET CALL_HOME_REQUESTS',
    RECEIVE_CALL_HOME_REQUESTS = '[CALL_HOME_REQUESTS] SET CALL_HOME_REQUESTS',
}

export default ActionType
